import {useIntl} from 'react-intl'
import {useXSSProtection} from './../../hooks/use-xss-protection'
import {useToast} from '../../hooks/use-toast'

export default function useOutletCodeFields({
    form: {
        control,
        formState: {errors}
    }
}) {
    const toast = useToast()
    const {formatMessage} = useIntl()
    const {validateField} = useXSSProtection()

    const fields = {
        code: {
            name: 'code',
            label: formatMessage({
                defaultMessage: 'Enter Your Code',
                id: 'use_outlet_code_fields.label.code'
            }),
            placeholder: '',
            defaultValue: '',
            type: 'text',
            autoComplete: 'off',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your code.',
                    id: 'use_outlet_code_fields.error.required_code'
                }),
                validate: (value) => validateField(toast, value, 'outlet-code-form', 'code')
            },
            error: errors?.['code'],
            control
        }
    }
    return fields
}
